import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  skeleton: {
    background: theme.white,
    backgroundSize: '200% 100%',
    borderRadius: theme.radius.sm,
  },

  title: {
    height: 24,
    width: 180,
  },

  link: {
    height: 20,
    width: 80,
  },
}));
